import React, { FormEvent, useContext, useState, useEffect, JSX } from 'react';
import { WorkflowContext } from "../../context/WorkflowContextProvider";
import Form from '@rjsf/mui';
import { IChangeEvent } from '@rjsf/core';
import { RJSFSchema, UiSchema, RegistryWidgetsType } from '@rjsf/utils';
import validator from '@rjsf/validator-ajv8';
import {useReactFlow, applyNodeChanges, ReactFlowInstance} from "@xyflow/react";
import SaveIcon from '@mui/icons-material/Save';
import DeleteIcon from '@mui/icons-material/Delete';
import { NodeDataStoreSelectWidget } from "./components/NodeDataStoreSelectWidget";
import { DefaultFormDialog  } from "./components/DefaultFormDialog";
import { processNodeDelete, processNodeFormSubmit, formSchema, nodeDescription } from "./functions/workflow-injection-node-configuration";
import {
    Button
} from '@mui/material';

export const WorkflowInjectionNodeConfiguration: () => JSX.Element = (): JSX.Element => {
    const context: any = useContext(WorkflowContext);
    const reactFlowInstance: ReactFlowInstance = useReactFlow();
    const [formData, setFormData] = useState<any>();

    function handleCloseDialog(): void {
        context.toggleShowInjectionModal(false);
    }

    const handleFormSubmit: (data: IChangeEvent, event: FormEvent<any>) => void = (data: IChangeEvent, event: FormEvent<any>) : void => {
        console.log(data.formData);
        processNodeFormSubmit(context, data.formData, reactFlowInstance);
        handleCloseDialog();
    }

    function deleteNode() {
        processNodeDelete(context, reactFlowInstance);
        handleCloseDialog();
    }


    const uiSchema: UiSchema = {

        'value_to_inject': {
            'ui:widget': 'NodeDataStoreSelectWidget',
            'ui:options': {
                'classNames': 'data-management',
                enumDisabled: [
                    'hq_params',
                    'scraper_pending'
                ]
            }
        },
        'injections': {
            'items': {
                'data_input': {
                    'ui:widget': 'NodeDataStoreSelectWidget',
                    'ui:options': {
                        enumDisabled: [
                            'messages',
                            'data_to_loop',
                            'latest_user_message',
                            'hq_params',
                            'scraper_pending'
                        ]
                    }
                },
                'data_management': {
                    'ui:widget': 'NodeDataStoreSelectWidget',
                    'ui:options': {
                        'classNames': 'data-management',
                        enumDisabled: [
                            'hq_params',
                            'scraper_pending'
                        ]
                    }
                },
            }

        }

        // 'ui:order': [
        //     'data_input',
        //     'convert_type',
        //     'root_tag',
        //     'lowercase_tags',
        //     'force_array',
        //     'trim_whitespace',
        //     'skip_header',
        //     'data_management' ]
    }

    const widgets: RegistryWidgetsType = {
        NodeDataStoreSelectWidget: NodeDataStoreSelectWidget
    }

    useEffect( (): void => {
        if (context.activeEditInjectionNode !== undefined && context.activeEditInjectionNode.data !== undefined) {
            setFormData(context.activeEditInjectionNode.data);
        }
    } , [context] );



    return (
        <DefaultFormDialog
            open={ context.showInjectionModal }
            title={ "Injection Node Configuration" }
            handleClose={ handleCloseDialog }
            description={ nodeDescription }
        >
            <span style={ { paddingLeft: '15px', fontWeight: 'bold' } }>{ "Node ID: " + context?.activeEditInjectionNode?.id }</span>
            <Form
                validator={validator}
                schema={ formSchema }
                uiSchema={ uiSchema }
                onSubmit={ handleFormSubmit }
                widgets={ widgets }
                formData={ formData }
                formContext={ formData }
                onChange={({ formData }) => setFormData(formData)}
            >
                <div className="dialog__actions form-group">
                    <Button type="submit"
                            variant="contained"
                            color="success"
                    >
                        <SaveIcon />
                        <span>{ "Save" }</span>
                    </Button>
                    <Button
                        variant="contained"
                        color="error"
                        onClick={ deleteNode }
                        type="button">
                        <DeleteIcon />
                        <span>{ "Delete" }</span>
                    </Button>

                </div>
            </Form>
        </DefaultFormDialog>
    );
}